<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-copyright element-with-heading" id="copyright">
<div class="heading heading-with-title heading-without-image" id="copyright-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Copyright</h1>
</div>
</div>
</div>
</div>
<div class="text" id="copyright-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content"><b>Queen of Legacy © 2020 Veronica Shade</b></p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">All rights reserved under the International and Pan-American Copyright Conventions. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher.</p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">This is a work of fiction. Names, places, characters and incidents are either the product of the author’s imagination or are used fictitiously, and any resemblance to any actual persons, living or dead, organizations, events or locales is entirely coincidental.</p>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center copyright-content">Warning: the unauthorized reproduction or distribution of this copyrighted work is illegal. Criminal copyright infringement, including infringement without monetary gain, is investigated by the FBI and is punishable by up to 5 years in prison and a fine of $250,000.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7a463688